// extracted by mini-css-extract-plugin
module.exports =  {"main":"---src-components-Shared-MenuBar__main--FFiiF","username":"---src-components-Shared-MenuBar__username--UfUYj"};